// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2PQEi","noInteraction":"EventWrapper_noInteraction__37Vy3","pointerPassthrough":"EventWrapper_pointerPassthrough__180ZL"};